module.exports = __webpack_public_path__ + "static/home_05-6ec5f27cce82bf004c1a44052b677d1a.webp";